<template>
<div> 
  <Header v-show="program.name" /> 
  <main class="container-fluid">  
    <section class='row mt-4'>
    <div class='col-4 px-3 py-3 d-none d-md-flex'></div>

    <div class='col-24 col-md-16 px-md-3 py-3 px-3 mb-md-5'>
      <div class='col d-column'>
        <div v-show="program.name" class='card mb-3'>
          <div class='card-body py-3'>
            <div class='row'>
              <div class='col-14'>
                <div class="h-profile h-profile-lg d-flex flex-row no align-items-center">
                  <div class="align-self-center d-flex align-items-center align-self-center pr-2">
                    <object width="62" height="62" class="rounded-circle img-lg" :data="program.avatar" type="image/png">
                      <img width="62" height="62" class="rounded-circle img-lg" src="../../assets/images/default.png" alt="Avatar">
                    </object>
                  </div>
                  <div class='d-flex flex-column'>
                    <h1 class='title pt-1' v-text="program.name"> </h1>
                    <div class="title">
                      <span v-text="$ml.with($utils.formatData(program.createdAt, $ml.get('ln'))).get('publishedDaysAgo')">Submetido há *</span>
                    </div>
                    <!-- <p v-text="$ml.with($utils.formatData(program.updatedAt, $ml.get('ln'))).get('lastReviewSubmittedAgo')">Última revisão enviada em</p> -->
                  </div>
                </div>
              </div>

              <div class='col-10 d-flex flex-column justify-content-center'>
                <div class='align-self-end'>
                  <a @click="submitReport()" class='btn btn-top' v-text="$ml.get('submitReport')">Submeter Relatório</a>
                </div> 
              </div> 
            </div> 
          </div> 
        </div> 
 
        <div v-show="program.policy" class='row'>
          <div class='col-24 col-md-17'>
            <div v-if="program.description" class='card mb-3'>
              <div class='card-header' v-text="$ml.get('summary')">
                Resumo
              </div>
              <div class='card-body' v-text="program.description"> </div>
            </div>

            <!-- <div> -->
              <!-- <b-nav tabs justified> -->
                <!-- <b-nav-item :active="menuItem === 'detail'" @click="menuItem = 'detail'">Detalhes</b-nav-item> -->
                <!-- <b-nav-item v-show="program.type == 'vdp'" :active="menuItem === 'hallOfFame'" @click="changeRanking() ,menuItem = 'hallOfFame'">Agradecimentos</b-nav-item>   -->
                <!-- <b-nav-item @click="changeRanking() ,menuItem = 'hallOfFame'">Agradecimentos</b-nav-item>   -->
                <!-- <b-nav-item :active="menuItem === 'update'" @click="menuItem = 'update'">Atualizações</b-nav-item> -->
              <!-- </b-nav> -->
            <!-- </div> -->
<!-- Details of program -->
            <div v-show="menuItem === 'detail'" class='card card-no mb-3'> 
              <div class='card-body'>
                <div class='d-column flex-row'>
                  <div class='h-form h-profile-lg d-flex flex-column pb-3 align-items-center no'>
                    <div class='d-flex align-self-start'>
                      <div class='position-relative align-self-center d-flex align-items-center align-self-center'>
                        <div class='circle-number d-flex justify-content-center align-items-center'>
                          <span>1</span>
                        </div>
                      </div>
                      <div class='pl-3 d-flex'>
                        <div class='align-self-start mt-1'>
                          <h2 class='size-1_4 m-0 pb-1'><strong v-text="$ml.get('programPolicy')">Política do Programa</strong></h2>
                          <p class='d-flex align-items-center'><span class='align-self-center' v-text="$ml.get('aGoodPolicAvoids')">
                              Uma boa política evita problemas, caso tenha algum problema nos consulte.
                            </span></p>
                        </div>
                      </div>
                    </div>
                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>
                    <div class='d-flex align-self-start h-profile-circle'>
                      <div class='circle d-flex justify-content-center flex-row'>
                        <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
                        <div class='h-line'><span></span></div>
                        <div class='v-line'><span></span></div>
                      </div>
                      <div class='d-flex flex-column w-100 mr-3 pl-3'>
                        <div class='col-14 pb-2'>
                          <h6 v-if="program.type == 'public'" v-text="$ml.get('ccpProgPubli')">Programa Público</h6>
                          <h6 v-else>Vulnerability Disclosure Program</h6>
                        </div> 
                      </div> 
                    </div>
                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>
                    <div class='d-flex align-self-start h-profile-circle'>
                      <div class='circle d-flex justify-content-center'>
                        <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
                        <div class='h-line'><span></span></div>
                        <div class='v-line'><span></span></div>
                      </div>
                      <div class='d-flex flex-column w-100 mr-3'>
                        <p class='pl-3 mb-3' v-text="$ml.get('aboutTheProgramPolicy')">Sobre a política do programa!</p>
                        <div class='card card-body mx-md-3 d-flex w-100 px-3'>  
                          <div class='d-flex flex-column w-100'>
                            <div class='form-control h-100' >
                              <p v-if="program.policy" v-html="$utils.convertMarkedOld(program.policy)"> 
                              </p>
                            </div> 
                          </div> 
                        </div>
                      </div>
                    </div>
                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-5'></span></div>
                    </div>

                    <div class='d-flex align-self-start'>
                      <div class='position-relative align-self-center d-flex align-items-center align-self-center'>
                        <div class='circle-number d-flex justify-content-center align-items-center'>
                          <span>2</span>
                        </div>
                      </div>
                      <div class='pl-3 d-flex'>
                        <div class='align-self-start mt-1'>
                          <h2 class='size-1_4 m-0 pb-1'><strong v-text="$ml.get('scope')">Escopo</strong></h2>
                          <p class='d-flex align-items-center'>
                            <span class='align-self-center' v-text="$ml.get('scopeListOfTheProgram')">
                              Lista de escopo do programa!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>
                    <div class='d-flex align-self-start h-profile-circle'>
                      <div class='circle d-flex justify-content-center'>
                        <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
                        <div class='h-line'><span></span></div>
                        <div class='v-line'><span></span></div>
                      </div>
                      <div class='d-flex flex-column w-100 mr-3'>
                        <p class='pl-3 mb-3' v-text="$ml.get('delimitationOfDomainsSubdomains')">Delimitação de domínios, subdomínios, aplicativos e outros</p>

                        <div class='card card-body ml-md-3 p-0 d-flex w-100'> 
                          <table class='mb-2'>
                            <thead v-if="program.scope">
                              <tr>
                                <th class='col-10' v-text="$ml.get('scope')">Escopo</th>
                                <th class='col-9 pl-0' v-text="$ml.get('type')">Tipo</th>
                                <th class='col-5 pl-0' v-text="$ml.get('severity')">Severidade</th>
                              </tr>
                            </thead>
                            <tbody> 
                              <tr v-if="!program.scope || !program.scope.length" class='d-flex align-items-center justify-content-center'>
                                <h6 class="my-3" v-text="$ml.get('noScopeAvailable')"> 
                                    Nenhum escopo disponível! 
                                </h6>
                              </tr> 
                              <tr v-else v-for="(item, index) in program.scope" :key="index" >
                                <td class='col-10'><strong><a v-text="item.description"></a></strong></td>
                                <td class='col-9 pl-0 text-muted'>{{item.type}}</td> 
                                <td class='col-5 pl-0'> 
                                  <Impact class='d-flex mt-1' :impact='"impact-"+item.severity'/> 
                                </td> 
                              </tr> 
                            </tbody> 
                          </table> 
                        </div>
                      </div>
                    </div>
                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>
            
                    <div v-if="program.offers_bounty || (program.optional_rewards && program.optional_rewards.length)" class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-5'></span></div>
                    </div>

                    <div v-if="program.offers_bounty || (program.optional_rewards && program.optional_rewards.length)" class='d-flex align-self-start'>
                      <div class='position-relative align-self-center d-flex align-items-center align-self-center'>
                        <div class='circle-number d-flex justify-content-center align-items-center'>
                          <span>3</span>
                        </div>
                      </div>
                      <div class='pl-3 d-flex'>
                        <div class='align-self-start mt-1'>
                          <h2 class='size-1_4 m-0 pb-1'><strong v-text="$ml.get('rewards')">Recompensas</strong></h2>
                          <p class='d-flex align-items-center'>
                            <span class='align-self-center' v-text="$ml.get('getAccessToExclusiveRewards')">
                              Tenha acesso à recompensas exclusivas deste programa!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div v-if="program.offers_bounty" class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>

                    <div v-if="program.offers_bounty" class='d-flex align-self-start h-profile-circle'>
                      <div class='circle d-flex justify-content-center'>
                        <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
                        <div class='h-line'><span></span></div>
                        <div class='v-line'><span></span></div>
                      </div>
                      <div class='d-flex flex-column w-100 mr-3'>
                        <p class='pl-3 mb-3' v-text="$ml.get('rewardsWithFinancialValues')">Recompensas com valores financeiros</p> 
                        <div class='card card-body ml-md-3 p-0 d-flex w-100'> 
                          <table class='mb-2'>
                            <thead>
                              <tr> 
                                <th class='pl-3 col-10 pl-0' v-text="$ml.get('impact')">Impacto</th>
                                <th class='col-14 pl-0' v-text="$ml.get('reward')">Recompensa</th>
                              </tr>
                            </thead>
                            <tbody>

                              <tr class="row">
                                <td class='col-10 row'><Impact class="mt-1 mr-1" impact='impact-low'/>
                                  <font v-text="$ml.get('low')">Baixo</font> 
                                </td>
                                <td class='col-14 pl-0'>
                                  <strong>{{$utils.convertMoney(program.bounty_low)}}</strong>
                                </td> 
                              </tr>

                              <tr class="row">
                                <td class='col-10 row'> <Impact class="mt-1 mr-1" impact='impact-medium'/>
                                  <font v-text="$ml.get('medium')">Médio</font> 
                                </td>
                                <td class='col-14 pl-0'>
                                  <strong>{{$utils.convertMoney(program.bounty_medium)}}</strong>
                                </td> 
                              </tr>

                              <tr class="row">
                                <td class='col-10 row'> <Impact class="mt-1 mr-1" impact='impact-high'/>
                                  <font v-text="$ml.get('high')">Alto</font>
                                </td>
                                <td class='col-14 pl-0'>
                                  <strong>{{$utils.convertMoney(program.bounty_high)}}</strong>
                                </td> 
                              </tr>

                              <tr class="row">
                                <td class='col-10 row'> <Impact class="mt-1 mr-1" impact='impact-critical'/>
                                  <font v-text="$ml.get('critical')">Crítico</font>
                                </td>
                                <td class='col-14 pl-0'>
                                  <strong>{{$utils.convertMoney(program.bounty_critical)}}</strong>
                                </td> 
                              </tr> 
                            </tbody>

                          </table> 
                        </div>
                      </div>
                    </div>

                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
                    </div>

                    <div v-if="program.optional_rewards && program.optional_rewards.length" class='d-flex align-self-start h-profile-circle'>
                      <div class='circle d-flex justify-content-center'>
                        <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
                        <div class='h-line'><span></span></div>
                        <div class='v-line'><span></span></div>
                      </div>
                      <div class='d-flex flex-column w-100 mr-3'>
                        <span class='pl-3 mb-3'>{{ $ml.get('otherTypes') }} <span v-text="$ml.get('ofReward')">de recompensa</span></span> 

                        <div class='card card-body ml-md-3 p-0 d-flex w-100'>
                          <table class='mb-2'>
                            <thead>
                              <tr> 
                                <th class='ml-3 col-24 pl-0' v-text="$ml.get('reward')">Recompensa</th>
                              </tr>
                            </thead>
                            <tbody> 
                              <tr v-for="(item, index) in program.optional_rewards" :key="index"> 
                                <td class='pl-3 col-24 pl-0' v-text="item"></td>
                              </tr>  
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    
                    <div class='d-flex align-self-start h-profile'>
                      <div class='v-line d-flex align-items-stretch'><span class='pb-5'></span></div>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
<!-- Hall of fame -->
            <div v-show="menuItem === 'hallOfFame'" class=" mb-3 mt-4">
          
              <div class="d-column flex-row ">

                <div class="loading d-flex">
                  <div v-if="loading"  class="c-loader"></div>
                  <h6 v-else v-show="!itensRank.length" class='p-1 mt-2'>O programa ainda não tem dados suficientes</h6>
                </div>

                <div class='d-flex flex-wrap mt-2 col-24'>
                  <div v-for="(item, index) in itensRank.slice(0, 8)" :key="index" class="col-12 col-md-12 col-lg-6 my-3  ">  
                      <div class='d-flex justify-content-center'>
                        <object class='d-flex justify-content-center' width="55" height="55" :data="item.avatar" type="image/png">
                          <img width="55" height="55" src="../../assets/images/default.png" alt="Avatar hacker">
                        </object> 
                        <div v-if="item.verified" class="verify_vdp">  
                          <img src="../../assets/icons/badge-check.png" width="16" height="16" />  
                        </div>
                      </div> 
                      <div class='col d-flex justify-content-center align-items-center'>
                        <div>
                          <h5 class="text-center mb-0 mt-1">{{index +1}}°</h5> 
                          <h5 class="text-center" v-text="item.username"></h5>
                          <p class="text-center"><strong>{{item.score}} Pontos</strong></p>
                        </div>
                      </div>   
                  </div>  
                </div>

                <hr v-show="itensRank.length" class="mt-3 mb-0" /> 
                <div v-for="(item, index) in itensRank.slice(8, )" :key="index" :class="'h-profile d-flex pt-3 pb-3 align-items-center ' + (itensRank.length - 8 == index +1? 'no':'')">
                  <div class="position-relative align-self-center d-flex align-items-center align-self-center" >

                    <object width="42" height="42" :data="item.avatar" type="image/png">
                      <img width="42" height="42" src="../../assets/images/default.png" alt="Avatar hacker">
                    </object>
              
                    <div v-if="item.verified" class="verify">  
                      <img src="../../assets/icons/badge-check.png" width="16" height="16" />  
                    </div>
                  </div>
                  <div class="pl-3 d-flex align-items-center d-flex w-100 justify-content-between" >
                    <div class="align-self-start">
                      <h3>
                        <a href="" class="link-block" v-text="item.username"></a>
                      </h3>
                      <p class="mt-1 text-dark d-flex justify-content-start">
                        {{item.score}} <font class="pl-1" v-text="$ml.get('points')"></font>
                        </p>
                    </div>
                    <div class="d-flex">
                      <div class="rank rank-relative">
                        <span class="p-2">{{index +9}}°</span> 
                      </div>
                    </div>
                  </div>
                </div>  
                
              </div>
              
            </div> 
<!-- Update -->
            <!-- <div v-show="menuItem === 'update'" class=" mb-3 mt-4"> 
              <div class="d-column flex-row "> 
                <div class="loading d-flex">
                  <div v-if="loading"  class="c-loader"></div>
                  <h6 v-else class='p-1 mt-2'>Nenhuma atualização disponível</h6>
                </div> 
              </div> 
            </div>  -->

          </div>
          
          <div class='col-24 col-md-7 pl-3'>
            <div class=' '> 
              <div class='card mb-3'>
                <div class='card-header' v-text="$ml.get('statistics')">
                  Estatísticas
                </div>
                <div class='card-body py-0 pt-2'>
                  <div class='d-flex flex-column'>
                    <div class='pt-3'> 
                      <h6><font v-text="$ml.get('reports')">Relatórios</font>: {{program.amount_of_submited_reports}}</h6>
                    </div>
                    <div class='pt-3'>
                      <h6><font v-text="$ml.get('openReports')">Relatórios abertos</font>: {{program.amount_of_open_reports}}</h6>
                    </div>
                    <div class='pt-3 pb-3'>
                      <h6><font v-text="$ml.get('closedReports')">Relatórios fechados</font> {{program.amount_of_closed_reports}}</h6> 
                    </div> 
                  </div>
                </div>
              </div>  
            </div> 
          </div>
        </div>   
      </div>
    </div>

  </section>
  </main>
</div>
</template>

<script> 
import header from "./header";
import ProgramService from "../../services/program.service";   
import RankingService from "../../services/ranking.service";   
import { mapActions } from "vuex";
const DOMPurify = require('dompurify'); 
const marked = require('marked'); 
export default { 
  components:{ 
    Header: header
  },
  page: { 
    meta: [{ name: "description"  }]
  },
  data() {
    return {
      menuItem: 'detail',
      itensRank: [],
      program: {
        optional_rewards: []
      },
      id: '',
      loading: false,
    };
  },
  created(){
    this.id = this.$route.params.slug; 
    this.changeProgram(this.id); 
  }, 
  destroyed() {
    this.$utils.updateTitlePage(
      "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
    );
  },
  methods: {
    ...mapActions(['setpProgramWithout']),

    changeProgram(id) { 
      this.optional_rewards = [];
      ProgramService.getProgramVdpDetail(id).then(
        (response) => {
          this.program = response.data;   
          this.$utils.updateTitlePage(
            this.program.name ??
              "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
          );
          this.program.policy = DOMPurify.sanitize(marked(this.program.policy));
        },
        () => {  
          this.$router.push('/program')
        }
      );
    },

    changeRanking() { 
      this.itensRank = [];
      this.loading = true;
      RankingService.getRankingVDP(this.$route.params.slug).then(
        (response) => { 
          this.loading = false; 
          this.itensRank = response.data.items;   
        }
      ).catch(
        () => { 
          this.loading = false; 
          this.itensRank = [];   
        }
      );
    },

    submitReport(){ 
      let id = this.$route.fullPath.split('?')[1]; 
      this.setpProgramWithout(id); 
      this.$router.push('/login') 
    }, 
  },
};
</script>  
<style lang="scss" scoped>
  .nav-tabs .nav-link { 
      font-weight: 500;
  } 
  .boxes-ranking {
    border-radius: 4px;
    width: 100%;
    height: auto;
    position: relative; 
  }
  .verify_vdp {
    position: absolute;
    margin-left: 50px;
  }
</style>
 